module.exports = __webpack_public_path__ + "img/Journey.6d643e29.svg";